import { HttpResponse } from '@angular/common/http';
import { Injectable, EventEmitter } from '@angular/core';
import { ApiGateway } from 'api/api-gateway';


@Injectable()
export class UnregisteredScheduleService {

    constructor(private apiGateway: ApiGateway) { }

    saveSchedule(schedule) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .post(
                    `datasnap/rest/TCalendarController/agendamentoSemPaciente/`,
                    schedule
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    consultaAgendamentoPorUnidadeEspecialidadeProfissional(idUnidade, idEspecialidade, idProfissional) {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .get(
                    `datasnap/rest/TCalendarController/consultaAgendamentoUnidadeEspecialidadeProfissional/${idUnidade}/${idEspecialidade}/${idProfissional}`
                )
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    buscarAgendamentoSemCadastro(credenciais): Promise<any> {
        return new Promise((resolve, reject) => {
            this.apiGateway
                .post("scheduling/app/unregistered", credenciais) // Mudando para POST
                .subscribe((res: HttpResponse<any>) => {
                    if (res.body) {
                        resolve(res.body);
                    } else {
                        resolve(res);
                    }
                }, reject);
        });
    }

    static mudarNavigation = new EventEmitter<boolean>();

}
